import * as React from "react";
import { EyeIcon, HideIcon } from "../icons";
import "./index.css";

const OutlinedInput = ({
  value,
  onChange,
  name,
  title,
  type,
  placeholder,
  className,
  leading,
  border,
  height,
  wrapperClassName,
  ...props
}) => {
  const inputRef = React.useRef();

  React.useEffect(() => {
    if (inputRef.current) {
      inputRef.current.addEventListener("wheel", () => {
        inputRef.current.blur();
      });
    }
  }, []);

  const isPassword = type === "password";
  const [showPassword, setShowPassword] = React.useState(false);

  return (
    <div
    className={`outlined-input-base ${wrapperClassName}`}
    >
      <span>{title}</span>
      <div
        className={`outlined-input-wrapper ${className}`}
        style={{
          border: border || "",
          height: height,
        }}
      >
        {leading && (
          <span className={`leading ${title && "with-title"} `}>{leading}</span>
        )}
        <input
          ref={inputRef}
          className={`outlined-input ${leading && "with-leading"} `}
          value={value}
          onChange={onChange}
          name={name}
          placeholder={placeholder || title}
          {...props}
          type={isPassword && showPassword ? "text" : type}
        />
        <span className="suffix" onClick={() => setShowPassword(!showPassword)}>
          {isPassword ? (
            showPassword ? (
              <EyeIcon size={25} />
            ) : (
              <HideIcon size={25} />
            )
          ) : undefined}
        </span>
      </div>
    </div>
  );
};

export default OutlinedInput;
